import { Controller } from '@hotwired/stimulus'
let timer = ''
export default class UserController extends Controller {
  static targets = ['confirmButton']

  updatePaymentType(event) {
    event.preventDefault()
    $(event.target).closest('form')[0].requestSubmit()
  }

  toggleButton(e) {
    const selected = e.target.value
    const button = this.confirmButtonTarget

    $('.delete-account').removeClass('disabled')

    if (selected === 'Delete') {
      $('.delete-account-options').removeClass('d-none')

      button.dataset.confirmationConfirmTextValue = 'Yes'
    } else {
      $('.delete-account-options').addClass('d-none')
      $('.delete-account-options input[type="checkbox"]').prop('checked', false)

      button.dataset.confirmationConfirmTextValue = 'Yes, deactivate it!'
    }
  }

  submitData(event) {
    $(event.target).closest('form')[0].requestSubmit()
  }

  addNotification(event) {
    $(event.target).closest('form')[0].requestSubmit()
  }

  removeData(e) {
    const $container = $(this.element)
      .closest('.analytics-page')
      .find('.interest-value')
    let interestId = $(this.element).prev('span').data('value')
    this.element.closest('.remove-interest').remove()
    $('select option[value=' + interestId + ']').prop('disabled', false)
    if ($container.children().length === 0) {
      $container.removeClass('d-flex').addClass('d-none')
    }
    let array_name = []
    $('.interest-name-value').each(function (index, element) {
      array_name.push($(element).attr('data-value'))
    })
    fetch('/connects?interest_name=' + array_name, {
      method: 'get',
      headers: {
        Accept: 'text/vnd.turbo-stream.html',
        'X-CSRF-Token': document.getElementsByName('csrf-token')[0].content,
        'Content-Type': 'application/json'
      }
    })
      .then((r) => r.text())
      .then((html) => {
        Turbo.renderStreamMessage(html)
      })
  }

  userSearch(e) {
    clearTimeout(timer)
    timer = setTimeout(function () {
      e.preventDefault()
      let form = $(e.target).closest('form')
      form[0].requestSubmit()
    }, 500)
  }

  closeMessageSearch(e) {
    const form = e.currentTarget.closest('form')
    form.querySelector('.message-search').value = ''

    const url = new URL(globalThis.location.href)
    url.searchParams.delete('request')
    url.searchParams.delete('message')

    Turbo.visit(url.toString(), {
      frame: 'chat-area'
    })
  }

  showMoreAccounts(e) {
    const showMoreButton = $(e.currentTarget)
    const hiddenElements = showMoreButton
      .closest('.card-container')
      .find('.hiddenAccount')
    const hiddenElements1 = showMoreButton
      .closest('.bank-account-container')
      .find('.hiddenAccount')
    hiddenElements.removeClass('d-none')
    hiddenElements1.removeClass('d-none')
    showMoreButton.hide()
  }

  changeValue(e) {
    const value = Number.parseInt(e.target.value, 10)
    const scale =
      Number.parseInt(e.target.dataset.min) +
      value / Number.parseInt(e.target.dataset.divide || 1)
    document.documentElement.style.setProperty(e.target.dataset.property, scale)

    const sliderEl = e.target
    const isTextSize = sliderEl.classList.contains('text-size-slider')
    let tempSliderValue = Number.parseInt(sliderEl.value)
    if (isTextSize) {
      tempSliderValue = Math.floor(tempSliderValue / 2) * 2
    }
    sliderEl.value = tempSliderValue
    const progress = (tempSliderValue / sliderEl.max) * 100
    sliderEl.style.background = `linear-gradient(to right, #E85BF4 ${progress}%, #1EC92F ${progress}%)`
    const form = $(e.target).closest('form')
    form[0].requestSubmit()
  }

  togglePrivacySafety(e) {
    e.preventDefault()
    const scheduleManuallyCheckbox = $('.schedule_manually_check_box')
    const privacySafetyDiv = $('.privacy-safety')
    const riseToSetCheckbox = $('.sunset_check_box')
    const customCheckbox = $('.custom_select')
    const turnOnOffDiv = $('.turn-on-off')
    const form = $(e.target).closest('form')
    if (scheduleManuallyCheckbox.prop('checked')) {
      privacySafetyDiv.removeClass('d-none')
      if (riseToSetCheckbox.prop('checked')) {
        turnOnOffDiv.removeClass('d-none')
      } else {
        turnOnOffDiv.addClass('d-none')
        customCheckbox.prop('checked', false)
      }
    } else {
      privacySafetyDiv.addClass('d-none')
      turnOnOffDiv.addClass('d-none')
      customCheckbox.prop('checked', false)
    }
    form[0].requestSubmit()
  }

  toggleCustom(e) {
    e.preventDefault()
    const isCustom = $('.custom_select')
    const isRise = $('.sunset_check_box')
    const privacySafetyDiv = $('.turn-on-off')
    const form = $(e.target).closest('form')
    if ($(e.target).hasClass('custom_select')) {
      isRise.prop('checked', false)
      isCustom.prop('checked', true)
      privacySafetyDiv.removeClass('d-none')
    }
    if ($(e.target).hasClass('sunset_check_box')) {
      isRise.prop('checked', true)
      isCustom.prop('checked', false)
      privacySafetyDiv.addClass('d-none')
    }
    form[0].requestSubmit()
  }

  addRemoveTopics(e) {
    let id = $(this.element).attr('data-value')
    let type = $(this.element).attr('data-type')

    fetch('/topics/' + id + '/add_remove_topics?type=' + type, {
      method: 'PUT',
      headers: {
        'X-CSRF-Token': document.getElementsByName('csrf-token')[0].content,
        Accept: 'text/vnd.turbo-stream.html',
        'Content-Type': 'application/json'
      }
    })
      .then((r) => r.text())
      .then((response) => {
        Turbo.renderStreamMessage(response)
      })
  }

  showMoreTopics(e) {
    Turbo.visit('/topics/?type=show_more')
  }
}
